var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-col",
    {
      staticClass: "px-2 my-2",
      staticStyle: { "flex-wrap": "nowrap" },
      attrs: { cols: "12", xl: "6", lg: "4", md: "4", sm: "12" },
    },
    [
      _c(
        "v-card",
        {
          staticStyle: { height: "inherit", padding: "4px" },
          attrs: { loading: _vm.loading },
        },
        [
          _c(
            "v-list-item",
            {
              class: _vm.selected ? "selected" : "",
              attrs: { disabled: _vm.disabled },
              on: { click: _vm.handleSelectionClick },
            },
            [
              _vm._t("avatar", function () {
                return [
                  _c(
                    "v-list-item-avatar",
                    { attrs: { size: "64px" } },
                    [
                      _vm._t("avatar", function () {
                        return [
                          _c("v-img", {
                            attrs: { height: "100%", src: _vm.previewImage },
                          }),
                        ]
                      }),
                    ],
                    2
                  ),
                ]
              }),
              _c(
                "v-list-item-content",
                [
                  _c(
                    "v-list-item-title",
                    [
                      _c(
                        "v-row",
                        {
                          staticStyle: {
                            "align-items": "center",
                            "flex-wrap": "wrap",
                            height: "64px",
                          },
                          attrs: { "no-gutters": "" },
                        },
                        [
                          _c(
                            "v-col",
                            {
                              staticStyle: { "vertical-align": "middle" },
                              attrs: { cols: "auto" },
                            },
                            [
                              _c("p", { staticClass: "ma-0" }, [
                                _vm._v(" " + _vm._s(_vm.hall.Title) + " "),
                              ]),
                            ]
                          ),
                          _c(
                            "v-col",
                            {
                              staticClass: "d-flex ml-1",
                              attrs: { cols: "auto" },
                            },
                            _vm._l(
                              _vm.getHallBookedAndPayedTags(_vm.hall),
                              function (tag, index) {
                                return _c("Tag", {
                                  key:
                                    "tag_bookedPayedHallPrev" +
                                    _vm.hall.Id +
                                    "_" +
                                    index,
                                  attrs: { tagCount: 2, tagInfo: tag },
                                })
                              }
                            ),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            2
          ),
          _c(
            "v-row",
            { staticClass: "mt-1 px-4", attrs: { "no-gutters": "" } },
            [
              _c(
                "v-slide-group",
                { attrs: { "show-arrows": "" } },
                _vm._l(_vm.hall.tags, function (tag, index) {
                  return _c("Tag", {
                    key: "tag_hallPrev" + _vm.hall.Id + "_" + index,
                    attrs: { tagCount: _vm.hall.tags.length, tagInfo: tag },
                  })
                }),
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }